
import { Component, Vue } from 'vue-property-decorator'
import { ApplicationDto, getApplication, modifyApplicationListFavorite } from '@/api/homes'
import draggable from 'vuedraggable'
import JumpWarn from '@/views/financial/JumpWarn.vue'
import { Action, Getter } from 'vuex-class'
import { getUserOtherInfoFCD, getSyDictDataInfo } from '@/api/commonConfig'
import { getPreCredit, getPreCreditUrl } from '@/api/preCredit'
import { getAvoidLoginUrl, getWhiteSign } from "@/api/iousServices";
import { openNewPage, openFDWhitePage } from '@/utils/h5ToApp'
import dayjs from "dayjs"
@Component({
    name: 'ApplicationList',
    components: {
        draggable,
        JumpWarn
    }
})
export default class ApplicationList extends Vue {
    @Getter userId!: string
    @Getter info: any // 用户信息
    @Getter companyId: string // 公司id
    @Getter companyName: string // 公司名称
    @Getter whiteStrips!: number
    @Getter mobile!: string
    @Action setRootPath!: (val: string) => void;
    active = 0 // 列表tabs选中id

    // 常用应用
    favoriteList: ApplicationDto[] = []
    isEdit = false // 管理 or 完成

  // 所有应用(已分类)
  allApp:any[]=[]

  whiteSignTime = ''
  endSignTime = ''

  created () {
    // 清楚飞贷白条缓存数据
    window.localStorage.removeItem('FDWhite')
    getSyDictDataInfo({dictTypeId: 'applyClassify'}).then((res: any) => {
      this.allApp = res.data
      this.getApplication()
    })
    this.getSign()
  }
    show = false
    canPreCredit = false
    msg1 = ''
    msg2 = ''

    mounted () {
        // 注册原生调用h5返回事件
        this.handleAppBack()
    }

    /**
  * @description: 获取预授信免登陆接口
  * @param {*} null
  * @return {*} null
  */
  handleConfirm() {
    console.log('userType',this.info.userType);
    let type = this.info.userType
    let params:any = {
      userId:this.userId
    }
    if(type === '2') {
      params = {
        userId2:this.userId
      }
    }
    if(!this.canPreCredit) return
    getPreCreditUrl(params).then(res => {
        console.log('getPreCreditUrl',res);
        openNewPage({url: encodeURI(res.data.redirectUrl)})
    })
  }

    /**
     * 监听原生APP的返回事件
     */
    handleAppBack () {
        this.$bridge.registerHandler(
            'applicationBack', () => {
                this.handleBack()
            }
        )
    }

    /**
     * 获取全部应用
     */
    getApplication () {
        let parmas = {
            partnerCompanyId: this.info.partnerCompanyId || 'system',
            scope: '1' // 查询来源
        }
        getApplication(parmas).then(res => {
            this.favoriteList = res.data.favoriteList
            this.favoriteList.map(item => {
                if (res.data.allList.filter(data => {
                    if (data.applicationId === item.applicationId) {
                        item.route = data.route
                        item.applicationLogo = data.applicationLogo
                        item.applicationName = data.applicationName
                        item.parentId = data.parentId
                    }
                }))
                    item = this._handleAction(item)
            })
            this._handleAppDatas(res.data.allList)
        })
    }


  _handleAppDatas (apps: ApplicationDto[]) {
    // 重置 所有应用
    this.allApp.map(item=>{
      item.children =  []
    })
    apps.map(app => {
      app.isAddShow = this.favoriteList.some(faItem => {return faItem.applicationId === app.applicationId})
      app = this._handleAction(app)
      this.allApp.filter(item=> {
        if(item.dataId === app.parentId){
          item.children.push(app)
        }
      })
    })
  }

    /**
     *  应用数据绑定权限
     */
    _handleAction (app: ApplicationDto) {
        app.action = app.route.substring(1, app.route.length)
        return app
    }


    /**
     * 删除常用应用
     * @param url
     */
    handleDelete (app: ApplicationDto, index: number) {
        if (this.favoriteList.length === 1) {
            this.$toast('至少选择一个常用应用')
            return false
        }

    // 给删除的应用在全部应用里面添加 添加按钮显示
    this.allApp.map((item, index) => {
      if (item.dataId === app.parentId) {
        item.children.map((apppitem) => {
          if (apppitem.applicationId === app.applicationId) {
            apppitem.isAddShow = false
            this.$set(this.allApp, index, item)
          }
        })
      }
    })
    this.favoriteList.splice(index, 1)
  }

    /**
     * 添加应用
     * @param index
     */
    handleAdd (app: ApplicationDto) {
        if (this.favoriteList.some(item => {return item.applicationId === app.applicationId})) {
            this.$toast('该应用已添加')
            return false
        }
        if (this.favoriteList.length === 4) {
            this.$toast('最多选择4个常用应用')
            return false
        }
        let parma = {
            applicationId: app.applicationId,
        }
        app.isAddShow = true
        this.favoriteList.push(app)
    }

    /**
     * 点击返回
     */
    handleBack () {
        if (this.isEdit) {
            this.$confirmDialog.show({
                okText: '确认退出',
                cancelText: '继续编辑',
                tips: '你编辑的应用还没有保存，确定退出吗？',
                onOk: () => {
                  this.$router.replace('/homes')
                }
            })
        } else {
            this.$router.replace('/homes')
        }
    }

    /**
     * 进入应用内部
     * @param link
     */
    goApp (link: string, applicationName: string) {
        // 如果正在编辑,无法跳转进应用用
        if (this.isEdit) {
            return false
        }
        this.setRootPath('/applicationList')
        if (applicationName === '金融服务') { 
        this.getAuthority()
        return false
        }
        if (link === '/financialServices') {
            this._getInfoFCD()
            return false
        }
        if (link === '/valetOrder') {
          this.$router.push({ path:link,query:{fromPath:'3'}})
          return false
        }
        if(link === '/preVerifyPhone') {
          console.log('userType',this.info.userType);
          let type = this.info.userType
          let params:any = {
            userId:this.userId
          }
          if(type === '2') {
            params = {
              userId2:this.userId
            }
          }
          this.msg1 = ''
          this.msg2 = ''
          this.show = true
          getPreCredit(params).then((res) => {
            console.log('getPreCredit', res)
            if (res.code === '000000') {
              this.canPreCredit = true
            } else if (res.code === '000002') {
              this.canPreCredit = false
            }
            this.msg1 = res.data.msg
            this.msg2 = res.data.msg2
          })
          return false
        }
        this.$router.push(link)
    }

    /**
     * 判断用户金融服务授信是否已过期
     */
    _getInfoFCD () {
        getUserOtherInfoFCD({userId: this.userId}).then((res) => {
            if (res.code === '000000' && res.data.isExpire !== true) {
                //    跳转到金融服务页面
                this.$router.push({
                    path: '/financialServices',
                })
            } else {
                // 进入授信流程
                (this.$refs.jumpWarn as any).showModal()
            }
        })
    }

    // 保存or管理
    handleSave () {
        // if (!this.$action('edit')) {
        //     return false
        // }
        if (!this.isEdit) {
            this.isEdit = !this.isEdit
            return false
        }
        let applicationList = []
        this.favoriteList.map(item => {
            applicationList.push({
                applicationId: item.applicationId
            })
        })
        modifyApplicationListFavorite({applicationList: applicationList}).then(res => {
            this.$toast('保存成功')
            this.isEdit = !this.isEdit
        })
    }

    // 1还款入口 2授信入口 3借款入口 
  fdfreeLogin(flag = '') {
    let params = {
      companyId: this.companyId,
      webShow: flag
    }
    getAvoidLoginUrl({...params}).then((res) =>{
      const { code, data } = res
      if( code === "000000" ) {
        let encodeUrl = encodeURI(data.responseData.redirectUrl)
        let isQuery = encodeUrl.indexOf('?') > -1
        let url = `${encodeUrl}${isQuery? '&' : '?'}webShow=${flag}&userPhone=${this.mobile}` //+ (flag == '' ? `&companyName=${this.companyName}` : '')
        // openNewPage({url})
        // window.location.href = url
        openFDWhitePage({url})
        console.log('getAvoidLoginUrl=',url);
      }
    }).catch(() => {
      this.$toast('此产业商城暂未开通白条快付')
    })
  }

  getAuthority() {
    switch (this.whiteStrips) {
      case 2:
        this.$dialog
          .confirm({
            message: "开通金融服务需完成企业认证",
            confirmButtonText: "去认证",
            cancelButtonText: "取消认证",
          })
          .then(() => {
            // 白条需求支付标识，用于人脸识别使用
            window.localStorage.setItem('FDWhite','1')
            window.localStorage.setItem('isFinance','1')
            this.$router.push({
              path: "/companyInfoForm",
              query: {
                formPage: "h5",
              },
            });
          })
          .catch(() => {});
        break;
      case 3:
        this.$dialog
          .confirm({
            message: "开通金融服务需完成个人身份认证，且身份为持股比例大于5%的股东",
            confirmButtonText: "去认证",
            cancelButtonText: "取消认证",
          })
          .then(() => {
            // 白条需求支付标识，用于人脸识别使用
            window.localStorage.setItem('FDWhite','1')
            window.localStorage.setItem('isFinance','1')
            this.$router.push({
              path: "/userInfoForm",
              query: {
                formPage: "h5",
              },
            });
          })
          .catch(() => {});
        break;
      case 5:
        this.$dialog
          .confirm({
            message: "当前账号不符合金融服务开通条件，需企业法人或持股比例大于5%股东才可开通，若您身份已变更，可前往身份认证进行修改",
            confirmButtonText: "去认证",
            cancelButtonText: "取消认证",
          })
          .then(() => {
            this.$router.push({
              path: "/userInfoForm",
              query: {
                formPage: "h5",
              },
            });
          })
          .catch(() => {});
        break;
      case 1:
      case 4:
        // 是否签署授权书
        if (window.localStorage.getItem('isSign') == '1' && this.whiteSignTime < this.endSignTime) {
          this.fdfreeLogin()
        } else {
          window.localStorage.removeItem('isSign')
          this.$router.push({
            path: "/iousAuthorize",
            query: {
              cykjSource: 'homes'
            }
          })
        }
        break;
    }
  }

  // 获取授权书记录
  getSign() {
    getWhiteSign().then((res =>{
      const { code, data } = res
      if( code === "000000" && data) {
        let firstSignTime = data.whiteSignTime
        firstSignTime = dayjs(firstSignTime).format("YYYY-MM-DD")  
        this.endSignTime = dayjs(firstSignTime).add(360, 'day').format("YYYY-MM-DD");
        this.whiteSignTime = dayjs().format("YYYY-MM-DD");
        console.log('首次签署日期=======',firstSignTime);
        console.log('再次签署日期=======',this.endSignTime);
        if (this.whiteSignTime < this.endSignTime) window.localStorage.setItem('isSign','1')
      }
    }))
  }
}
